// @flow
import News from 'components/hub/News';
import { connect } from 'react-redux';

import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/hub/News';
import { fetchArticlesStaticCategories } from 'actions/newsletterActions';

export default connect(
  (state: StateType): StateProps => ({
    categoriesArticle: state.newsletterState.categoriesArticle,
    clubName: state.settingsState.title,
    settingsStatus: state.settingsState.status,
    actualite_ffr_vers_ecosysteme: state.settingsState.actualite_ffr_vers_ecosysteme,
    actualite_une: state.settingsState.actualite_une,
    actualites_une_titre: state.settingsState.actualites_une_titre,
    actualites_une_description: state.settingsState.actualites_une_description,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchArticlesStaticCategories: () => dispatch(fetchArticlesStaticCategories()),
  }),
)(News);
